export default __webpack_public_path__ + "static/media/ai1.b7714a0e.png";